import { useTranslation } from '@thoughtspot/i18n';
import cx from 'classnames';
import _ from 'lodash';
import React, { useState } from 'react';
import { Button } from '../../button';
import { Icon, IconColor, IconID } from '../../icon';
import { Horizontal } from '../../layout';
import styles from './pagination-dots.module.scss';
import { getPaginationDots, hoverPaginationDotIconID } from './pagination-dots.util';
/**
 * The PaginationDots is basic component to represent the pagination dots and it requires the total number of objects.
 * It brings the next set of object of the page when we click on the next and previous button
 */
export const PaginationDots = ({ total, offset, batchSize, previous, next, jumpTo, }) => {
    const { t } = useTranslation();
    const paginationDotProp = getPaginationDots(Math.ceil(total / batchSize), Math.floor(offset / batchSize) + 1);
    // Only having one page.
    if (_.isNil(paginationDotProp) || total <= batchSize) {
        return React.createElement("div", { "data-testid": "no-pagination" });
    }
    const getLeftButton = () => {
        return (React.createElement(Button, { ariaLabel: t('PREVIOUS'), "data-testid": "PaginationLeftButton", className: cx(styles.paginationLeft, {
                [styles.enabled]: paginationDotProp.disablePrevious === false,
            }), onClick: previous, isDisabled: paginationDotProp.disablePrevious, icon: IconID.CHEVRON_LEFT, iconClassName: styles.paginationIcon, type: "tertiary", size: "s", retainFocusOnClick: false }));
    };
    const getRightButton = () => {
        return (React.createElement(Button, { ariaLabel: t('NEXT'), "data-testid": "PaginationRightButton", className: cx(styles.paginationRight, {
                [styles.enabled]: paginationDotProp.disableNext === false,
            }), onClick: next, isDisabled: paginationDotProp.disableNext, icon: IconID.CHEVRON_RIGHT, iconClassName: styles.paginationIcon, type: "tertiary", size: "s", retainFocusOnClick: false }));
    };
    const PaginationDot = ({ icon, size, pageIndex, }) => {
        const [isMouseHover, setIsMouseHover] = useState(false);
        // Selected pagination dot will not have hover effect and clickability.
        if (icon === IconID.CIRCLE) {
            return (React.createElement(Horizontal, { className: styles.dotContainer, "data-testid": `pagination-dot-${pageIndex}` },
                React.createElement(Icon, { id: icon, color: IconColor.GRAY, size: size, className: styles.dot })));
        }
        return (React.createElement(Horizontal, { className: styles.cursorPointer, onClick: () => jumpTo(pageIndex), onMouseOver: () => setIsMouseHover(true), onMouseOut: () => setIsMouseHover(false), "data-testid": `pagination-dot-${pageIndex}` },
            React.createElement(Icon, { id: isMouseHover ? hoverPaginationDotIconID : icon, color: IconColor.GRAY, size: size, className: styles.dot })));
    };
    return (React.createElement(Horizontal, { vAlignContent: "center", hAlignContent: "center", className: styles.pagination },
        getLeftButton(),
        paginationDotProp.dots.map((paginationDot) => (React.createElement(PaginationDot, { ...paginationDot, key: paginationDot.key }))),
        getRightButton()));
};
//# sourceMappingURL=pagination-dots.js.map